import Location from "../../features/rapidstor/entities/Location";
import React from "react";
import Card from "react-bootstrap/Card";
import classes from "./ContactCard.module.scss";
import SmallDetail from "../SmallDetail";
import PhoneNumber from "../PhoneNumber";
import imageL002 from "../../assets/facility-L002.png";
import imageL003 from "../../assets/facility-L003.png";
import imageL004 from "../../assets/facility-L004.png";
import imageL007 from "../../assets/facility-L007.png";
import imageL008 from "../../assets/facility-L008.jpg";
import imageL005 from "../../assets/facility-L005.jpg";
import imageL009 from "../../assets/facility-L009.jpeg";
import imageL011 from "../../assets/facility-L011.png";
import imageDefault from "../../assets/facility-default.png";
import Header from "../Header";
import { ReactComponent as IconPhone } from "../../assets/icon-phone.svg";
import { ReactComponent as IconEmail } from "../../assets/icon-email.svg";

interface Props {
  location: Location;
}

function ContactCard({ location }: Props) {
  const image =
    {
      L002: imageL002,
      L003: imageL003,
      L004: imageL004,
      L007: imageL007,
      L008: imageL008,
      L005: imageL005,
      L009: imageL009,
      L011: imageL011,
    }[location.locationCode] ?? imageDefault;

  const addressLine = [location.address.address1, location.address.address2]
    .filter(Boolean)
    .join(" ");
  return (
    <Card className={`h-100 ${classes.card}`}>
      <Card.Img src={image} variant={"top"}></Card.Img>
      <Card.Body className={"d-flex flex-column"}>
        <Header level={2} bold className={"mb-2"}>
          Storage {location?.name}
        </Header>
        <SmallDetail className={"opacity-50 mb-2 mb-lg-3"}>
          {addressLine}, {location.address.city} {location.address.region}
        </SmallDetail>
        <div
          className={`d-flex align-items-center mb-2 mt-lg-auto mb-lg-4 ${classes.phone}`}
        >
          <IconPhone className={"text-primary"} />
          <PhoneNumber phoneNumber={location.contactPhone} />
        </div>
        <div className={"d-flex align-items-center"}>
          <IconEmail className={`me-2 me-lg-3 opacity-40 ${classes.secondaryIcon}`} />
          <a href={`mailto:${location.contactEmail}`} className={"link transparent"}>
            Email us
          </a>

          {/*
          <IconChat
            className={`ms-4 ms-lg-auto me-2 me-lg-3 opacity-40 ${classes.secondaryIcon}`}
          />
          <a href={"#"} className={"link transparent"}>
            Chat
          </a>
          */}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ContactCard;
